<script lang="ts">
  import type { SellSheet } from "@shared/types/SellSheet";
  import { convertToFormattedLocaleDate } from "@shared/svelte/Components/DateFormatter/LocaleString.svelte";
  import UIRouterLink from "@shared/svelte/Components/UIRouterLink.svelte";
  import ProductImage from "@shared/svelte/Components/ProductImage.svelte";
  import { isAwsS3Image } from "@shared/svelte/Modules/AwsS3Service";
  import { SellSheetEntity, DistributorEntity } from "@shared/services/event_tracking/entities";

  export let sellSheet: SellSheet;

  let componentWidth = null;
  let numItemsToShow = 2;
  let hasHiddenItems = false;

  $: responsiveLayout = componentWidth < 800;

  let shared_by = sellSheet.sell_sheet_shares[0].shared_by_user;

  $: {
    componentWidth;
    if (componentWidth) {
      numItemsToShow = Math.floor(componentWidth / 108) - 1;
      hasHiddenItems = numItemsToShow < sellSheet.sell_sheet_product_lines.length;
    }
  }

</script>

<style>
  .responsive-layout {
    display: inline-flex;
    flex-flow: column;
  }

  .hidden-items {
    margin-left: auto;
    margin-right: 2.5rem;
  }

  .hidden-items-left {
    margin-left: auto;
    margin-right: auto;
  }

</style>

<UIRouterLink
  stateName="layout.sell_sheet"
  button={false}
  params={{ sellSheetId: sellSheet.id }}
  style="color: unset; text-decoration: none;"
  eventName="sell_sheet_index_sell_sheet_card_click"
  useTrackClick
  trackingParams={[
    new SellSheetEntity({
      sheetId: sellSheet.id,
    }),
    new DistributorEntity({
      id: sellSheet.distributor?.id,
    }),
  ]}
>
  <div
    bind:clientWidth={componentWidth}
    id="sell-sheet-{sellSheet.id}"
    class="fizz-card fizz-bordered fizz-stack-24"
    data-testId="sell-sheet-card"
  >
    <div class="fizz-card fizz-card-padded fizz-border-bottom">
      <div class:fizz-space-between={!responsiveLayout}>
        <div class="sell-sheet-info" class:responsive-layout={responsiveLayout}>
          <p
            class="fizz-stack-4"
            class:responsive-layout={responsiveLayout}
            class:fizz-stack-8={responsiveLayout}
          >
            <span class="fizz-text-strong fizz-text-large">{sellSheet.name}</span>
            {#if sellSheet.notes}
              <span class="fizz-text-large"
                >{#if !responsiveLayout}•{/if}
                {sellSheet.notes}</span
              >
            {/if}
          </p>
          <p class="fizz-stack-4" class:responsive-layout={responsiveLayout}>
            <span>{convertToFormattedLocaleDate(sellSheet.sell_sheet_shares[0].created_at)}</span>
            <span>
              {#if !responsiveLayout}•{/if}
              {shared_by.first_name + " " + shared_by.last_name}, {sellSheet.distributor
                ?.retailer_facing_name}</span
            >
          </p>
        </div>
        {#if !responsiveLayout}
          <div class="sell-sheet-link" data-testId="view-sell-sheet-button">
            <UIRouterLink
              stateName="layout.sell_sheet"
              button={true}
              params={{ sellSheetId: sellSheet.id }}
              eventName="sell_sheet_index_view_sell_sheet_button_click"
              useTrackClick
              trackingParams={[
                new SellSheetEntity({
                  sheetId: sellSheet.id,
                }),
                new DistributorEntity({
                  id: sellSheet.distributor?.id,
                }),
              ]}
              stopPropagation
            >
              <button class="fizz-button">View sheet</button>
            </UIRouterLink>
          </div>
        {/if}
      </div>
    </div>
    <div class="fizz-card fizz-card-padded fizz-flex-row-16">
      <div class="fizz-flex-row-4 fizz-flex-wrap">
        {#each sellSheet.sell_sheet_product_lines.slice(0, numItemsToShow) as sspl}
          <div class="fizz-stack-4 sell-sheet-image">
            <ProductImage
              width={75}
              height={isAwsS3Image(sspl.product_line_images[0]?.cloudinary_image_url) ? 75 : 100}
              product={sspl.product_line_images[0]}
              fizz={true}
            />
          </div>
        {/each}
      </div>
      <div
        class="fizz-text-center"
        class:hidden-items={!responsiveLayout}
        class:hidden-items-left={responsiveLayout}
      >
        {#if hasHiddenItems}
          <span class="fizz-text-large fizz-text-strong fizz-text-subdued">+ more</span>
        {/if}
      </div>
    </div>
    {#if responsiveLayout}
      <div
        class="sell-sheet-link fizz-inset-square-16 fizz-text-center"
        data-testId="view-sell-sheet-button"
      >
        <UIRouterLink
          stateName="layout.sell_sheet"
          button={true}
          params={{ sellSheetId: sellSheet.id }}
          eventName="sell_sheet_index_view_sell_sheet_button_click"
          useTrackClick
          trackingParams={[
            new SellSheetEntity({
              sheetId: sellSheet.id,
            }),
            new DistributorEntity({
              id: sellSheet.distributor?.id,
            }),
          ]}
          stopPropagation
        >
          <button class="fizz-button">View sheet</button>
        </UIRouterLink>
      </div>
    {/if}
  </div>
</UIRouterLink>
